export default "__VITE_ASSET__DCHakpr3__"